import { Button, Modal } from "antd";

function ValidatePartnerPopup({ open, onOk, onCancel }) {
  return (
    <Modal
      className="validateModal"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button onClick={(e) => onCancel()} key={"cancel"}>
          Cancel
        </Button>,
        <Button
          onClick={(e) => onOk()}
          className="footerButtonSave"
          key={"save"}
        >
          Save
        </Button>,
      ]}
    >
      <div className="validateWrapper">
        <h2>Confirm Partner Validation</h2>
        <p>Please confirm partner has all required information</p>
        <ol
          style={{
            transform: "translateX(-15px)",
            marginTop: "0",
          }}
          type="1"
        >
          <li>Contract signed (when needed)</li>
          <li>Bank statement</li>
          <li>Certificate of incorporation</li>
          <li>Partner contact details</li>
        </ol>
      </div>
    </Modal>
  );
}

export default ValidatePartnerPopup;
